export const HEADER_HEIGHT = 100;